var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"root-time-warp-timer"},[_c('div',{staticClass:"content inner-wrap"},[_c('span',{staticClass:"label"},[_vm._v("Stake your TIME tokens in ETH, BSC and Polygon pools and get rewards!")]),_c('a',{attrs:{"href":"https://timewarp.finance/","target":"_blank","rel":"noopener nofollow"}},[_vm._v("Learn more")])])])
}]

export { render, staticRenderFns }